// Authentication and cache management utilities
import { cookieManager, CookieName } from './cookieManager';
import { appStorage } from './appStorage';
import logger from './logger';

// localStorageに移行したキー（cookieManager.jsのLOCAL_STORAGE_KEYSと同じ）
const LOCAL_STORAGE_KEYS = [
  'user_info',
  'course_id',
  'course',
  'chapter_id',
  'chapter',
  'vocabulary_id',
  'vocabulary',
];

export const authManager = {
  // Check if user is authenticated (has both user_email and app_id)
  isAuthenticated() {
    const userEmail = cookieManager.getCookie(CookieName.UserEmail);
    const appId = appStorage.getAppId();

    return !!(userEmail && appId);
  },

  // Clear all authentication data and cache (current app only)
  clearAllData() {
    try {
      // 現在のアプリのプレフィックス付きキーをlocalStorageから削除
      const appName = appStorage.getAppName()
        || new URLSearchParams(window.location.search).get('app');
      if (appName) {
        const prefix = appName.toLowerCase();
        LOCAL_STORAGE_KEYS.forEach(key => {
          localStorage.removeItem(`${prefix}_${key}`);
        });
      }

      // Clear app context from sessionStorage
      appStorage.clear();

      // Clear cookie-based keys (user_email, device_id)
      cookieManager.removeCookie(CookieName.UserEmail);
      cookieManager.removeCookie(CookieName.DeviceId);
      
      // Clear known localStorage items (app-specific settings)
      // アプリ別設定キーを削除
      if (appName) {
        const prefix = appName.toLowerCase();
        localStorage.removeItem(`${prefix}_settings`);
        localStorage.removeItem(`${prefix}_retry_practice_list`);
      }
      // 旧共有キーも削除（マイグレーション後の残り）
      localStorage.removeItem('smartEnglishSettings');
      localStorage.removeItem('smartenglish_retry_practice_list');
      
      logger.log('All authentication data and cache cleared');
      return true;
    } catch (error) {
      logger.error('Error clearing authentication data:', error);
      return false;
    }
  },

  // Get authentication status and redirect accordingly
  checkAuthAndRedirect(router) {
    if (this.isAuthenticated()) {
      // User is authenticated, redirect to home
      router.replace('/home');
    } else {
      // User is not authenticated, clear all data and redirect to login
      const currentApp = appStorage.getAppName();
      this.clearAllData();
      router.replace(`/login?app=${currentApp || 'smartenglish'}`);
    }
  }
};
